import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-ministries-list',
  templateUrl: './ministries-list.component.html',
  styleUrls: ['./ministries-list.component.css']
})
export class MinistriesListComponent implements OnInit {
  loading = false;
  affiliation: any = null;
  baseUrl = environment.baseUrl;

  constructor(private auth: AuthenticationService) { }

  ngOnInit(): void {
    this.fetchAffiliations();
  }

  private fetchAffiliations(): void {
    this.loading = true;
    this.auth.getData('/merchant/affiliation').subscribe((res: any) => {
      const a = res?.data?.affiliation || res?.affiliation || null;
      this.affiliation = a;
      this.loading = false;
    }, _ => {
      this.loading = false;
      this.affiliation = null;
    });
  }

  img(url?: string, fallback = 'assets/images/org-placeholder.png'): string {
    if (!url) { return fallback; }
    if (/^https?:\/\//i.test(url)) { return url; }
    return `${this.baseUrl}/${url}`;
  }

  detailUrl(): string {
    const id = this.affiliation?.communityId || this.affiliation?._id;
    if (!id) { return 'https://personal.ravel.faith/#/detail-page?keyword=Ministries'; }
    return `https://personal.ravel.faith/#/detail-page?keyword=Ministries&id=${id}`;
  }

  faithLine(): string {
    const f = this.affiliation?.faith;
    const b = this.affiliation?.faithBranch;
    const d = this.affiliation?.faithDenomination;
    const getName = (x: any) => x && typeof x === 'object' ? (x.name || '') : (typeof x === 'string' ? x : '');
    const parts = [getName(f), getName(b), getName(d)].filter((s: string) => !!s && s.trim().length > 0);
    return parts.join(' | ');
  }

}

